import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface FilterOptions {
  locations: string[];
  religiosityLevels: string[];
  educationLevels: string[];
  ethnicities: string[];
  maritalStatuses: string[];
  citizenshipStatuses: string[];
  sects: string[];
}

export function useProfileFilterOptions() {
  const [options, setOptions] = useState<FilterOptions>({
    locations: [],
    religiosityLevels: [],
    educationLevels: [],
    ethnicities: [],
    maritalStatuses: [],
    citizenshipStatuses: [],
    sects: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        // Fetch all profiles to get distinct values
        const { data: profiles, error } = await supabase
          .from("profiles")
          .select("location, religiosity_level, education_level, ethnicity, marital_status, citizenship_status, sect");

        if (error) throw error;

        // Extract unique values for each field
        const uniqueLocations = [...new Set(profiles?.map(p => p.location).filter(Boolean))].sort();
        const uniqueReligiosity = [...new Set(profiles?.map(p => p.religiosity_level).filter(Boolean))].sort();
        const uniqueEducation = [...new Set(profiles?.map(p => p.education_level).filter(Boolean))].sort();
        const uniqueEthnicities = [...new Set(profiles?.map(p => p.ethnicity).filter(Boolean))].sort();
        const uniqueMaritalStatuses = [...new Set(profiles?.map(p => p.marital_status).filter(Boolean))].sort();
        const uniqueCitizenship = [...new Set(profiles?.map(p => p.citizenship_status).filter(Boolean))].sort();
        const uniqueSects = [...new Set(profiles?.map(p => p.sect).filter(Boolean))].sort();

        setOptions({
          locations: uniqueLocations,
          religiosityLevels: uniqueReligiosity,
          educationLevels: uniqueEducation,
          ethnicities: uniqueEthnicities,
          maritalStatuses: uniqueMaritalStatuses,
          citizenshipStatuses: uniqueCitizenship,
          sects: uniqueSects,
        });
      } catch (error) {
        console.error("filter_options.fetch_failed");
      } finally {
        setLoading(false);
      }
    };

    fetchFilterOptions();
  }, []);

  return { options, loading };
}
